import { useEffect, useCallback, useState } from 'react';
import { setSession } from './utils';
import axios from 'axios';
import { endpoints } from '@/lib/axios/axios-global';
import { useAppDispatch } from '@/core/global-store';
import { logout, setCredentials, setMe } from '@/core/global-store/features/auth/authSlice';
import { unwrapSanctumMeResponse } from './utils';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/Loading/LoadingSpinner';

const STORAGE_KEY = 'accessToken';

type Props = {
    children: React.ReactNode;
};

export function AuthInitializer({ children }: Props) {
    const dispatch = useAppDispatch();
    const [isUserLoggedin, setIsUserLoggedin] = useState<boolean>(false);
    const navigate = useNavigate();

    const initialize = useCallback(async () => {
        try {
            const accessToken = Cookies.get(STORAGE_KEY);

            if (accessToken) {
                setSession(accessToken);

                const res = await axios.get(endpoints.auth.me);
                const mePayload = unwrapSanctumMeResponse(res.data);

                dispatch(setMe(mePayload));
                dispatch(setCredentials({ token: accessToken, user: (mePayload ?? res.data) as any }));
                setIsUserLoggedin(true);
            } else {
                dispatch(logout());
                navigate('/login', { replace: true });
            }
        } catch {
            dispatch(logout());
            navigate('/login', { replace: true });
        }
    }, []);

    useEffect(() => {
        initialize();
    }, [initialize]);

    if (!isUserLoggedin) {
        return <LoadingSpinner />;
    }

    return <>{children}</>;
}
